import { type FC } from "react"
import { useTranslation } from "react-i18next"
import Box from "@mui/material/Box"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"

import type { TableStatColumn, TableStatRow } from "types/dashboard.types"

interface LabelCellProps {
  column: TableStatColumn
  row: TableStatRow
}

const justifyByAlign = {
  left: "flex-start",
  center: "center",
  right: "flex-end",
} as const

const LabelCell: FC<LabelCellProps> = ({ column, row }) => {
  const { t } = useTranslation()

  const labelKey = row.labels?.[column.key] ?? row.labelKey

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent={justifyByAlign[column.align ?? "left"]}
      gap={0.75}
      minWidth={0}
    >
      {row.color && (
        <Box
          sx={{
            width: 6,
            height: 6,
            borderRadius: "50%",
            bgcolor: row.color,
            flexShrink: 0,
          }}
        />
      )}
      <Typography fontWeight="700" fontSize="0.8rem" noWrap>
        {t(labelKey)}
      </Typography>
    </Stack>
  )
}

export default LabelCell
